
<div class="h-100">
  <div class="search">
    <search :o="$data"></search>
  </div>
  <div class="d-flex p-1 pb-2 header">
    <div class="d-flex actions my-auto pl-2">
      <div title="Add selected accounts to a household"
           :class="[
             `btn`,
             `action-button`,
             hasMissingOnDB
               ? `btn-outline-primary`
               : `btn-outline-secondary`,
           ]"
           v-on:click="click(`add`, `accounts`)">
        <i class="fas fa-plus-square"></i>
        <span>Import</span>
      </div>
      <div  v-if="isNCA"
           title="Add new NCA account"
           class="btn btn-outline-secondary action-button"
           v-on:click="addNCAAccount()">
        <i class="fas fa-plus-square"></i>
        <span>Add NCA account</span>
      </div>
      <div  v-if="isNCA"
           title="Add new NCA account"
           class="btn btn-outline-secondary action-button"
           v-on:click="updateNCAAccount()">
        <i class="fas fa-plus-square"></i>
        <span>Update account values</span>
      </div>
      <div title="Create Household"
           class="btn btn-outline-secondary action-button"
           v-on:click="click(`create`, `household`)">
        <i class="fas fa-house-user"></i>
        <span>Create Household</span>
      </div>
    </div>
    <div class="d-flex filters my-auto align-items-center">
      <div title="Filter: No Household"
           class="btn action-button"
           :class="classFilter(`div-filter`, `household`)"
           v-on:click="click(`filter`, `household`)">
        <i class="fas fa-filter"
           :class="classFilter(`filter`, `household`)"></i>
        <span>No Household</span>
      </div>
      <div title="Filter: No Contract"
           class="btn action-button"
           :class="classFilter(`div-filter`, `contract`)"
           v-on:click="click(`filter`, `contract`)">
        <i class="fas fa-filter"
           :class="classFilter(`filter`, `contract`)"></i>
        <span>No Contract</span>
      </div>
    </div>
    <div class="flex-grow-1 text-right" style="display: flex; flex-direction: column">
      <span>
        <span v-text="recordsSummary"></span>
        &nbsp;<i v-if="syncing" class="fas fa-sync fa-spin pl-1" title="Syncing custodian accounts..."></i>
      </span>
      <span v-text="selectedText"></span>
    </div>
    <div v-if="ready" class="ml-2 dropdown">
      <button class="btn btn-link text-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fas fa-ellipsis-v"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" href="#" @click.prevent="downloadCSV()">
          <i class="fas fa-download mr-2"></i>
          Download CSV
        </a>
        <a class="dropdown-item" href="#" @click.prevent="refresh()">
          <i class="fas fa-sync mr-2"></i>
          Refresh
        </a>
      </div>
    </div>
  </div>
  <template v-if="ready">
  <scroll-area class="pr-3">
    <a ref="download" class="d-none"></a>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>
            <checkbox :o="selectAllState"
                      p="selected"
                      :disabled="disabled(`select-all`)"
                      v-on:change="change(`select`)"></checkbox>
          </th>
          <th>
            <span>Number</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`number`)"
               v-on:click="sort(`number`)"></i>
          </th>
          <th>
            <span>Name</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`name`)"
               v-on:click="sort(`name`)"></i>
          </th>
          <th>
            <span>Household</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`household`)"
               v-on:click="sort(`household`)"></i>
          </th>
          <th>
            <span>Contract</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`contract`)"
               v-on:click="sort(`contract`)"></i>
          </th>
          <th>
            <span>Value</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`value`)"
               v-on:click="sort(`value`)"></i>
          </th>
        </tr>
      </thead>
      <tbody :key="bodyKey">
        <tr v-for="(o, index) in items"
            :key="index">
          <td>
            <i title="This account is missing on the most recent custodian data."
               v-if="o.isMissingOnCustodian"
               class="fas fa-exclamation-triangle missing-account-icon"></i>
            <checkbox v-else
                      :o="rowCheckStates[o.number] || { selected: false }"
                      p="selected"
                      :disabled="disabled(`select`, o)"
                      v-on:change="change(`select`, o)"></checkbox>
          </td>
          <td>
            <a href="#" class="badge badge-custom"
                  :title="title(`account`)"
                  v-on:click="open(`account`, o)"
                  v-text="o.number"></a>
          </td>
          <td>
            <span v-text="o.name"></span>
          </td>
          <td>
            <template v-if="o.household != NONE">
              <a href="#" class="badge badge-custom"
                    :title="title(`household`)"
                    v-on:click="open(`household`, o)"
                    v-text="o.household"></a>
            </template>
            <template v-else>
              <span v-text="o.household"></span>
            </template>
          </td>
          <td>
            <template v-if="o.contract != NONE">
              <a href="#" class="badge badge-custom"
                    :title="title(`contract`)"
                    v-on:click="open(`contract`, o)"
                    v-text="o.contract"></a>
            </template>
            <template v-else>
              <span v-text="o.contract"></span>
            </template>
          </td>
          <td>
            <span v-text="displayValue(o)" class="value-pill"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </scroll-area>
  </template>
  <template v-else>
    <loading></loading>
  </template>
</div>
